import { merchantApi } from '@/config/axios'

export interface MerchantBelongingVO {
  id?: number
  softwareId?: string
  agentId?: number
  agentName?: string
  agentNo?: string
  regionName?: string
  bindMode?: number
  confirmed?: boolean
  signTime?: string
}

export interface MerchantAgentOptionVO {
  id: number
  name?: string
  agentNo?: string
  regionName?: string
  regionExclusive?: boolean
}

export interface MerchantSoftwareOptionVO {
  softwareId: string
  softwareName?: string
}

export const getBelongingList = (merchantId: number) =>
  merchantApi.get<MerchantBelongingVO[]>({
    url: '/merchant-api/agent/belonging/list',
    params: { merchantId }
  })

export const confirmBelonging = (data: {
  merchantId: number
  softwareId: string
  agentId?: number
  inviteCode?: string
  regionCode?: string
  regionName?: string
}) => merchantApi.post({ url: '/merchant-api/agent/belonging/confirm', data })

export const autoAssignBelonging = (params: {
  merchantId: number
  softwareId: string
  regionCode?: string
  regionName?: string
}) =>
  merchantApi.post<boolean>({
    url: '/merchant-api/agent/belonging/auto-assign',
    params
  })

export const getBelongingAgents = (params?: { regionCode?: string; regionName?: string }) =>
  merchantApi.get<MerchantAgentOptionVO[]>({
    url: '/merchant-api/agent/belonging/agents',
    params
  })

export const getBelongingSoftware = () =>
  merchantApi.get<MerchantSoftwareOptionVO[]>({
    url: '/merchant-api/agent/belonging/software'
  })

export const getBelongingAutoAssignEnabled = () =>
  merchantApi.get<boolean>({
    url: '/merchant-api/agent/belonging/auto-assign-enabled'
  })

export const applyBelongingChange = (data: {
  merchantId: number
  softwareId: string
  changeType: number
  targetAgentId?: number
  reason?: string
}) => merchantApi.post({ url: '/merchant-api/agent/belonging/change-apply', data })

export const getBelongingChangeList = (merchantId: number) =>
  merchantApi.get({
    url: '/merchant-api/agent/belonging/change-list',
    params: { merchantId }
  })
